import lineAnimation from '../line/index.animation';
export default {
  "*.dataset.spline": lineAnimation['*.dataset.line']
};